import React from "react";
import { useState } from "react";
import { FaPlusCircle, FaMinusCircle, FaFileContract, FaExclamationCircle, FaGift, FaQuestionCircle  } from "react-icons/fa";
import ProductTermsAndConditions from "../ProductTerms&Conditions";
import Disclaimer from "../Disclaimer";
import RewardsProgram from "../RewardsProgram";
import FAQSection from "../FAQ";


const InfoAccordion = () => {
  const [openSection, setOpenSection] = useState(null);

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  return (
    <div className="pricing-main">
      <div className="pricing-header-content">
        <h4
          className="pricing-content-subtitle pricing-dropdown-btn"
          onClick={() => toggleSection("terms")}
        >
          <span className="pricing-icon">
            <FaFileContract color="#004AAD"/>
            Read our Terms and Conditions
          </span>
          {openSection === "terms" ? (
            <FaMinusCircle />
          ) : (
            <FaPlusCircle />
          )}
        </h4>
        {openSection === "terms" && (
          <ProductTermsAndConditions/>
        )}
      </div>

      <div className="pricing-header-content">
        <h4
          className="pricing-content-subtitle pricing-dropdown-btn"
          onClick={() => toggleSection("disclaimer")}
        >
          <span className="pricing-icon">
            <FaExclamationCircle color="#004AAD"/>
            Disclaimer
          </span>
          {openSection === "disclaimer" ? (
            <FaMinusCircle />
          ) : (
            <FaPlusCircle />
          )}
        </h4>
        {openSection === "disclaimer" && (
          <Disclaimer/>
        )}
      </div>

      <div className="pricing-header-content">
        <h4
          className="pricing-content-subtitle pricing-dropdown-btn"
          onClick={() => toggleSection("rewards")}
        >
          <span className="pricing-icon">
            <FaGift color="#004AAD"/>
            Rewards Program
          </span>
          {openSection === "rewards" ? (
            <FaMinusCircle />
          ) : (
            <FaPlusCircle />
          )}
        </h4>
        {openSection === "rewards" && (
          <RewardsProgram/>
        )}
      </div>

      <div className="pricing-header-content">
        <h4
          className="pricing-content-subtitle pricing-dropdown-btn"
          onClick={() => toggleSection("faq")}
        >
          <span className="pricing-icon">
            <FaQuestionCircle color="#004AAD"/>
            FAQ
          </span>
          {openSection === "faq" ? (
            <FaMinusCircle />
          ) : (
            <FaPlusCircle />
          )}
        </h4>
        {openSection === "faq" && (
          <FAQSection/>
        )}
      </div>
    </div>
  );
};
export default InfoAccordion;
